/* Buy Now snapshot restore — partner of MainProductSection._initBuyBtn().

   The Buy Now flow snapshots the original cart, clears it, adds just the
   buy-now item, and hands off to Shopflo. When the user comes back —
   success, abandon, back button, tab switch — this script puts the
   original cart back.

   Triggers (each calls runRestore once if a snapshot exists):
     1. Initial page load (immediate)
     2. `pageshow` — fires for bfcache restores when user hits back
     3. `visibilitychange` → visible — best-effort for in-page overlays
     4. After restore on /cart, soft-reload so the SSR'd cart UI rebuilds
*/
(function () {
  var KEY = '_solved_buynow_snapshot';
  var inFlight = false;

  function isCheckoutPath() {
    return window.location.pathname.indexOf('/checkout') === 0;
  }

  function readSnapshot() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var items = JSON.parse(raw);
      return items && items.length ? items : null;
    } catch (_) {
      return null;
    }
  }

  function clearSnapshot() {
    try {
      localStorage.removeItem(KEY);
    } catch (_) {}
  }

  function runRestore() {
    if (inFlight || isCheckoutPath()) return;
    var items = readSnapshot();
    if (!items) {
      clearSnapshot();
      return;
    }
    inFlight = true;

    /* Clear-then-add → cart ends exactly equal to snapshot regardless of
       whether checkout succeeded (cart empty) or was abandoned (cart has
       buy-now item). */
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function () {
        clearSnapshot();
        /* On /cart the SSR'd cart HTML is now stale — reload so the user
           sees the restored items, not the pre-restore state. */
        var p = window.location.pathname;
        if (p === '/cart' || p === '/cart/') {
          window.location.reload();
        }
      })
      .catch(function () {
        /* Leave snapshot in place to retry on next trigger. */
      })
      .finally(function () {
        inFlight = false;
      });
  }

  try {
    runRestore();

    window.addEventListener('pageshow', function (e) {
      /* persisted = bfcache restore; also catch normal pageshow that
         might race the immediate run on slow page loads. */
      if (readSnapshot()) runRestore();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && readSnapshot()) {
        runRestore();
      }
    });
  } catch (_) {
    /* fail silent — never break the page */
  }
})();
